import React, { Component } from 'react';
import {
  StatusBar,
  View,
  Modal,
  TouchableWithoutFeedback,
  Dimensions,
  SafeAreaView,
  Image,
} from 'react-native';
import VideoPlayer from 'react-native-video';

import PropTypes from 'prop-types';

import Controls from './Controls';
import styles from './Video.Styles';

class Video extends Component {
  constructor(props) {
    super(props);
    const { width, height } = Dimensions.get('window');

    this.screenWidth = width;
    this.screenHeight = height;

    this.state = {
      paused: true,
      muted: false,
      fullScreen: false,
      duration: 0,
      progress: 0,
      currentTime: 0,
      seeking: false,
      isRotated: !props.forceLandsacpe ? false : height > width,
      mainModalViewXPosition: 0,
      resizeMode: 'cover',
      loading: true,
      minimizedPlayerCurrentTime: 0,
    };
  }

  componentDidMount() {
    this.changeListener = Dimensions.addEventListener('change', this.onRotated);
  }

  componentWillUnmount() {
    this.changeListener.remove();
  }

  onRotated = ({ window: { width, height } }) => {
    this.screenWidth = width;
    this.screenHeight = height;
    const orientation = width > height ? 'LANDSCAPE' : 'PORTRAIT';
    if (this.props.forceLandsacpe && orientation === 'PORTRAIT') {
      this.setState({
        isRotated: true,
        resizeMode: 'contain',
      });
    } else if (this.props.forceLandsacpe && orientation === 'LANDSCAPE') {
      this.setState({
        isRotated: false,
      });
    }
  };

  onModalMainViewLayout = ({ nativeEvent: { layout } }) => {
    this.setState({
      mainModalViewXPosition: layout.x,
    });
  };

  onLoad = data => {
    this.setState(
      {
        duration: data.duration,
        paused: true,
      },
      () => {
        this.player && this.player.seek(this.state.minimizedPlayerCurrentTime);
      },
    );
  };

  onSeekRelease = percent => {
    const seconds = percent * this.state.duration;
    this.setState({ progress: percent, seeking: false }, () => {
      this.player.seek(seconds);
    });
  };

  progress = time => {
    const { currentTime } = time;
    const progress = currentTime / this.state.duration;
    if (!this.state.seeking) {
      this.setState({ progress, currentTime }, () => {
        this.minimizedPlayer && this.minimizedPlayer.seek(currentTime);
      });
    }
  };

  minimizedPlayerProgress = time => {
    const { currentTime } = time;
    this.setState({
      minimizedPlayerCurrentTime: currentTime,
      loading: false,
    });
  };

  togglePlay = () => {
    this.setState({ paused: !this.state.paused });
  };

  toggleFS = () => {
    this.setState({ fullScreen: !this.state.fullScreen, paused: false });
  };

  toggleMute = () => {
    this.setState({ muted: !this.state.muted });
  };

  checkSource = uri => {
    return typeof uri === 'string' ? { source: { uri } } : { source: uri };
  };

  setupMinimizedVideoRef = ref => {
    this.minimizedPlayer = ref;
  };

  setupVideoRef = ref => {
    this.player = ref;
  };

  seek = percent => {
    const currentTime = percent * this.state.duration;
    this.setState({ seeking: true, currentTime });
  };

  render() {
    const {
      fullScreen,
      paused,
      muted,
      isRotated,
      progress,
      duration,
      currentTime,
      loading,
      mainModalViewXPosition,
      resizeMode,
    } = this.state;

    const { url, play, poster, forceLandsacpe } = this.props;

    return (
      <>
        <TouchableWithoutFeedback onPress={this.toggleFS}>
          <View style={styles.videoStyleView}>
            {loading && (
              <View style={styles.posterImageView}>
                <Image {...this.checkSource(poster)} style={styles.posterImageStyle} />
              </View>
            )}
            <VideoPlayer
              {...this.checkSource(url)}
              paused={fullScreen ? false : play}
              resizeMode="cover"
              repeat
              style={styles.videoStyle}
              ref={this.setupMinimizedVideoRef}
              muted
              onProgress={this.minimizedPlayerProgress}
            />
          </View>
        </TouchableWithoutFeedback>
        <Modal
          animationType="slide"
          transparent={false}
          onRequestClose={this.toggleFS}
          visible={fullScreen}
          supportedOrientations={['portrait', 'landscape']}
        >
          <SafeAreaView style={styles.videoBackground}>
            <StatusBar hidden />
            <View
              onLayout={this.onModalMainViewLayout}
              style={[
                styles.videoBackground,
                isRotated && [
                  {
                    marginTop: -mainModalViewXPosition,
                  },
                  styles.videoRotated,
                ],
              ]}
            >
              <VideoPlayer
                {...this.checkSource(url)}
                paused={!paused}
                repeat={false}
                style={styles.fullScreen}
                ref={this.setupVideoRef}
                muted={muted}
                onLoad={this.onLoad}
                onProgress={this.progress}
                ignoreSilentSwitch="ignore"
                resizeMode={forceLandsacpe && resizeMode}
              />
              <Controls
                toggleMute={this.toggleMute}
                toggleFS={this.toggleFS}
                togglePlay={this.togglePlay}
                paused={paused}
                muted={muted}
                onSeek={this.seek}
                onSeekRelease={this.onSeekRelease}
                progress={progress}
                currentTime={currentTime}
                duration={duration}
                isRotated={isRotated}
              />
            </View>
          </SafeAreaView>
        </Modal>
      </>
    );
  }
}

Video.propTypes = {
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  poster: PropTypes.string.isRequired,
  play: PropTypes.bool,
  forceLandsacpe: PropTypes.bool,
};

Video.defaultProps = {
  play: true,
  forceLandsacpe: true,
};

export default Video;
